import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import predictionsReducer from "redux-toolkit/predictions/slice";
import promisesReducer from "redux-toolkit/promises/slice";
import predictorsReducer from "redux-toolkit/predictors/slice";
import surveysReducer from "redux-toolkit/surveys/slice";

const combinedReducer = combineReducers({
  predictions: predictionsReducer,
  promises: promisesReducer,
  predictors: predictorsReducer,
  surveys: surveysReducer,
});

export const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});
